import { ExperienceActivationInstanceImpl } from "../experience-activation.js";
function arrayToInstances(activations) {
  return activations.map((item) => toInstances(item)).filter((i) => !!i).flat(2);
}
function toInstances(activation) {
  if (activation.instances == null)
    return [];
  return activation.instances.filter((instance) => instance.active !== false).map((instance) => new ExperienceActivationInstanceImpl(activation, instance));
}
export {
  arrayToInstances,
  toInstances
};
